export default __webpack_public_path__ + "static/media/santa_snowdown_2.6dd9c6ab.png";